import React from "react";
import { Link } from "react-router-dom";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const cardGrid = (className, cards) => (
  <div className={className}>
    {cards.map((card) => (
      <article className={card.className || ""} key={card.title}>
        <h3>{card.title}</h3>
        {card.body ? <p>{card.body}</p> : null}
        {card.items ? <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul> : null}
        {card.link ? <Link to={card.link.to} className={card.link.className || "route-link-inline"}>{card.link.label}</Link> : null}
        {card.links ? (
          <div className="route-link-btn-row">
            {card.links.map((link) => <Link to={link.to} className={link.className || "route-link-btn"} key={link.to}>{link.label}</Link>)}
          </div>
        ) : null}
      </article>
    ))}
  </div>
);

const officialLinks = [
  { href: "https://www.ascot.com/royal-ascot", label: "Official Royal Ascot 2026" },
  { href: "https://www.ascot.com/royal-ascot/dress-code", label: "Dress codes" },
  { href: "https://www.ascot.com/royal-ascot/enclosure-guide", label: "Enclosure guide" },
  { href: "https://www.ascot.com/plan-your-visit/travel-parking", label: "Travel and parking" },
];

const ascotTaxiRoute = {
  id: "ascot-taxi",
  path: "/ascot-taxi",
  liveStripVariant: "windsor",
  seo: {
    title: "Ascot Taxi - Royal Ascot 2026, Racecourse & Heathrow Transfers | CheapCabGrab",
    description:
      "Book Ascot taxis for Royal Ascot 2026, Ascot Racecourse, Ascot station, local hotels, Heathrow transfers and group travel. Fixed fares, licensed drivers and 24/7 support.",
    keywords:
      "Ascot taxi, Royal Ascot taxi, Ascot Racecourse taxi, Ascot to Heathrow taxi, Heathrow to Ascot taxi, Ascot station taxi, CheapCabGrab",
    canonical: "https://www.cheapcabgrab.com/ascot-taxi",
    ogTitle: "Ascot Taxi - Royal Ascot 2026 Racecourse Transfers",
    ogDescription:
      "Fixed-price Ascot taxis for Royal Ascot 2026, Ascot Racecourse, local hotels, Ascot station and Heathrow Airport.",
    serviceName: "CheapCabGrab - Ascot Taxi Service",
    areaServed: ["Ascot Racecourse", "Ascot Station", "Royal Ascot", "Heathrow Airport", "Windsor", "Slough", "Maidenhead"],
    offerCatalogName: "Ascot Taxi Routes",
    offerName: "Ascot fixed-price taxi service",
    offerDescription: "Fixed-price taxi transfers for Ascot Racecourse, Royal Ascot 2026, Heathrow Airport and nearby Berkshire towns.",
    reservationName: "Taxi booking in Ascot",
  },
  hero: {
    eyebrow: "Ascot taxi and racecourse transfers",
    h1: "Ascot Taxi - Royal Ascot 2026, Racecourse & Heathrow Transfers",
    subtitle: "Ascot Racecourse, Ascot station, local hotels and Heathrow airport specialists.",
  },
  heroLiveBanner: {
    kicker: "Final day live",
    title: "Royal Ascot tickets currently unavailable - first race 2:30pm",
    body: "No Royal Ascot tickets are currently available. Expect heavy pressure around Ascot Racecourse, Ascot Station, Windsor hotels and Heathrow routes before and after racing.",
    cta: "Book early for fixed taxi fares and no surge pricing.",
  },
  quote: {
    label: "Get instant Ascot taxi quotes",
    note: "Fixed fares - No surge pricing",
    presetPickup: "",
    presetDropoff: "",
    pickupPlaceholder: "Enter Ascot pickup postcode or address",
    dropoffPlaceholder: "Enter destination postcode or address",
  },
  flags: [
    "Final day live: no Royal Ascot tickets currently available",
    "Ascot Racecourse, Ascot station and hotel pickups",
    "Fixed fares agreed upfront - no meters",
    "Saloon, MPV, minibus and coach options",
  ],
  reviewPageKey: "/ascot-taxi",
  reviewAriaLabel: "Ascot taxi customer reviews",
  statusProfile: "ascot",
  lhrStatusKicker: "Live Ascot + Heathrow intelligence",
  lhrStatusTitle: "Live Ascot checks for Ascot taxis",
  statusIntro: "Live road, rail, weather and Heathrow route signals are checked throughout Royal Ascot week.",
  floatingCta: "Book Ascot Taxi",
  mobileCta: "Book Ascot Taxi",
  supportNudge: "Need Ascot taxi help?",
  sections: [
    {
      id: "royal-ascot-final-day-schedule",
      title: "Today's Royal Ascot final day schedule",
      body:
        "Saturday 20 June is the final day of Royal Ascot 2026. No tickets are currently available, so plan only if you already have entry, hospitality or local arrangements. Seven races run from 2:30pm to 6:10pm, with heavy pressure expected around racecourse exits, Ascot station and nearby hotel pickup points.",
      render: () => (
        <div className="ascot-day-schedule">
          {[
            ["The Norfolk Stakes", "2:30pm", "Group 2 - 2yo - £175,000 - Five furlongs"],
            ["The Hardwicke Stakes", "3:05pm", "Group 2 - 4yo+ - £250,000 - One Mile, Four Furlongs"],
            ["The Queen Elizabeth II Jubilee Stakes", "3:40pm", "Group 1 - 4yo+ - £1,000,000 - Six Furlongs"],
            ["The Jersey Stakes", "4:20pm", "Group 3 - 3yo - £175,000 - Seven Furlongs"],
            ["The Wokingham Stakes", "5:00pm", "Class 2 Heritage Handicap, 0-110 - 3yo+ - £175,000 - Six Furlongs"],
            ["The Golden Gates Stakes", "5:35pm", "Class 2 Handicap, 0-105 - 3yo - £120,000 - One Mile, Two Furlongs"],
            ["The Queen Alexandra Stakes", "6:10pm", "Conditions, Class 2 - 4yo+ - £120,000 - Two Miles, Six Furlongs"],
          ].map(([race, time, details]) => (
            <article key={race}>
              <div>
                <strong>{race}</strong>
                <small>{details}</small>
              </div>
              <span>{time}</span>
            </article>
          ))}
          <button
            type="button"
            className="route-link-btn ascot-schedule-cta"
            onClick={() => document.getElementById("route-quote-form")?.scrollIntoView({ behavior: "smooth", block: "start" })}
          >
            Travelling for a specific race? Get a fixed quote
          </button>
        </div>
      ),
    },
    {
      id: "royal-ascot-2026",
      title: "Royal Ascot 2026 taxi planning",
      body:
        "Royal Ascot 2026 runs from Tuesday 16 June to Saturday 20 June. Race week is busy around Ascot Racecourse, Ascot station, local hotels and nearby roads, so pre-booking is strongly recommended.",
      render: () => cardGrid("route-overview-grid", [
        {
          title: "Key event dates",
          items: [
            "Tuesday 16 June 2026",
            "Wednesday 17 June 2026",
            "Thursday 18 June 2026",
            "Friday 19 June 2026",
            "Saturday 20 June 2026",
          ],
        },
        {
          title: "Race day taxi use cases",
          items: [
            "Morning hotel-to-racecourse drop-offs",
            "Ascot station to racecourse transfers",
            "Evening return taxis after racing and hospitality",
            "MPVs for hats, luggage, picnic items and groups",
          ],
        },
        {
          title: "Official Ascot links",
          body: "Check tickets, dress code, enclosures and travel guidance directly with Ascot before travelling.",
          items: [
            "Tickets and party packages",
            "Dress codes and enclosure rules",
            "Windsor, Queen Anne and Royal Enclosure guidance",
            "Travel, parking and venue policy updates",
          ],
        },
      ]),
    },
    {
      id: "ascot-official-links",
      title: "Official Royal Ascot links",
      body: "Use these official Ascot links for event information. CheapCabGrab handles taxi planning and booking.",
      render: () => (
        <div className="route-links-grid">
          {officialLinks.map((link) => (
            <article key={link.href}>
              <h3>{link.label}</h3>
              <p>Open the official Ascot information before confirming race day plans.</p>
              <a href={link.href} className="route-link-btn" target="_blank" rel="noreferrer">
                Open official Ascot page
              </a>
            </article>
          ))}
        </div>
      ),
    },
    {
      id: "ascot-pickups",
      title: "Ascot pickup and drop-off coverage",
      body: "Ascot race days can involve crowds, road controls and busy station access. We help with clear Ascot Racecourse taxi pickup planning before you travel.",
      render: () => cardGrid("route-areas-grid", [
        {
          title: "Ascot Racecourse and station",
          items: [
            "Ascot Racecourse visitor drop-offs and returns",
            "Ascot station taxi connections",
            "Racecourse hotels and hospitality pickups",
            "Group travel for Windsor, Queen Anne and Royal Enclosure guests",
          ],
          link: { to: "/ascot-to-heathrow", label: "Ascot to Heathrow route ->" },
        },
        {
          title: "Nearby towns and hotels",
          items: [
            "Heathrow to Ascot racecourse and hotel transfers",
            "Windsor, Sunningdale, Virginia Water and Bracknell pickups",
            "Slough and Maidenhead connections for station or hotel stays",
            "Late evening returns after racing, hospitality and restaurants",
          ],
          link: { to: "/heathrow-taxi", label: "Heathrow taxi guide ->" },
        },
      ]),
    },
    {
      id: "ascot-airport-routes",
      title: "Ascot, Heathrow and group travel",
      body: "Use the Ascot taxi hub for local racecourse travel, or the dedicated airport route page for Heathrow transfers.",
      render: () => cardGrid("route-links-grid", [
        {
          title: "Ascot to Heathrow",
          body: "Fixed-price airport taxi from Ascot Racecourse, Ascot station, hotels and homes to Heathrow terminals.",
          link: { to: "/ascot-to-heathrow", label: "Open Ascot to Heathrow", className: "route-link-btn" },
        },
        {
          title: "Heathrow to Ascot",
          body: "Arriving for Royal Ascot or a local hotel stay? Use the quote form with Heathrow Airport as pickup and Ascot Racecourse as drop-off.",
          link: { to: "/heathrow-taxi", label: "Heathrow taxi transfers", className: "route-link-btn" },
        },
        {
          title: "MPV, minibus and coach",
          body: "Royal Ascot groups often need extra luggage space, coordinated pickup and pre-booked return times.",
          links: [
            { to: "/minibus", label: "Minibus" },
            { to: "/coach", label: "Coach", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "ascot-nearby-routes",
      title: "Nearby taxi routes from Ascot",
      body: "Ascot visitors often connect through Windsor, Slough and Maidenhead hotels before or after Royal Ascot. These local pages help with nearby airport and town travel.",
      render: () => cardGrid("route-links-grid", [
        {
          title: "Windsor taxis",
          body: "Useful for Windsor hotels, Windsor Castle visits and racegoers staying west of Heathrow.",
          link: { to: "/windsor-taxi", label: "Open Windsor taxi", className: "route-link-btn" },
        },
        {
          title: "Slough taxis",
          body: "Local taxi guidance for Slough hotels, stations and Heathrow transfers.",
          link: { to: "/slough-taxi", label: "Open Slough taxi", className: "route-link-btn" },
        },
        {
          title: "Maidenhead to Heathrow",
          body: "Fixed-price airport transfers for Maidenhead, Bray and nearby hotel pickups.",
          link: { to: "/maidenhead-to-heathrow", label: "Open Maidenhead route", className: "route-link-btn" },
        },
      ]),
    },
    {
      id: "ascot-faq",
      title: "Ascot taxi - FAQs",
      body: "Common questions for Ascot Racecourse, Royal Ascot 2026 and Heathrow taxi bookings.",
      render: () => (
        <div className="route-faq-grid">
          {[
            ["Should I pre-book a taxi for Royal Ascot 2026?", "Yes. Royal Ascot week is extremely busy around Ascot Racecourse and Ascot station, so pre-booking outward and return journeys is the safest option."],
            ["Can you collect from Ascot Racecourse after racing?", "Yes, but pickup points can depend on race day traffic controls and crowd movement. We recommend confirming your return timing and phone contact before travel."],
            ["Can you take us from Heathrow to Ascot?", "Yes. Heathrow to Ascot is a common airport transfer for racegoers, hotel guests and hospitality groups."],
            ["Do you offer MPVs or minibuses for Ascot?", "Yes. MPVs, minibuses and coach options are available for larger race day groups, extra luggage and coordinated hotel pickups."],
          ].map(([title, body]) => <article className="route-faq-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </div>
      ),
    },
    {
      id: "ascot-support",
      title: "Need help with an Ascot taxi booking?",
      body: "For Royal Ascot groups, hotel pickups, Heathrow Airport transfers or return timing after racing, contact support before booking.",
      render: () => (
        <div className="route-support-box">
          <p>Email: <a href="mailto:support@cheapcabgrab.com">support@cheapcabgrab.com</a></p>
          <p>
            For airport travel, use our <Link to="/ascot-to-heathrow">Ascot to Heathrow</Link> route or compare nearby{" "}
            <Link to="/windsor-to-heathrow">Windsor to Heathrow</Link>,{" "}
            <Link to="/slough-to-heathrow">Slough to Heathrow</Link> and{" "}
            <Link to="/taplow-to-heathrow">Taplow to Heathrow</Link> pages.
          </p>
        </div>
      ),
    },
  ],
};

const AscotTaxi = () => (
  <CcgRoutePremiumPage route={ascotTaxiRoute} QuoteComponent={PostcodeQuotenew} />
);

export default AscotTaxi;
